"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MultiSelectFilter;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _utils = require("@alycecom/utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../../../Icon/Icon"));

var _BaseButton = _interopRequireDefault(require("../../../Buttons/BaseButton"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    popper: {
      zIndex: 1,
      border: "1px solid ".concat(palette.primary.main),
      borderRadius: 5,
      minWidth: 240,
      maxWidth: 300,
      width: 'auto',
      backgroundColor: palette.common.white,
      marginTop: "".concat(spacing(1), "!important") // TODO Dirty hack, but I didn't find another way to fix it

    },
    listOption: {
      marginTop: 6,
      marginBottom: 6
    },
    listOptionText: {
      fontSize: 16,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.5,
      letterSpacing: 'normal',
      color: palette.text.primary
    },
    listIcon: {
      justifyContent: 'center'
    },
    loadIcon: {
      marginRight: spacing(1)
    },
    lockIcon: {
      marginLeft: spacing(-1.5)
    },
    disabled: {
      '&:disabled': {
        border: "1px solid ".concat(palette.grey.main)
      }
    }
  };
});
/**
 * Multi select field without search.
 *
 * @template FieldNameType
 * @param {Object} props
 * @param {string} props.label
 * @param {string} props.name
 * @param {IOption[]} props.options
 * @param {boolean} props.isLoading
 * @param {function(FieldNameType, IOption[], IOption, boolean): void} props.onChange
 * @param {() => void} props.onOpen
 * @param {IOption[]} props.value
 * @param {Partial<BoxProps>} props.buttonBoxProps
 * @param {boolean} props.disabled
 * @param {Object} props.overrideClasses
 *
 * @returns {ReactElement<FieldNameType>}
 */

function MultiSelectFilter(_ref2) {
  var label = _ref2.label,
      name = _ref2.name,
      options = _ref2.options,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      onChange = _ref2.onChange,
      _ref2$onOpen = _ref2.onOpen,
      onOpen = _ref2$onOpen === void 0 ? function () {} : _ref2$onOpen,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? [] : _ref2$value,
      _ref2$buttonBoxProps = _ref2.buttonBoxProps,
      buttonBoxProps = _ref2$buttonBoxProps === void 0 ? {
    width: 160,
    mr: 2
  } : _ref2$buttonBoxProps,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$overrideClasses = _ref2.overrideClasses,
      overrideClasses = _ref2$overrideClasses === void 0 ? {} : _ref2$overrideClasses;
  var classes = useStyles();

  var _useTheme = (0, _material.useTheme)(),
      colors = _useTheme.palette;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var open = Boolean(anchorEl);
  var id = open ? "autocomplete-popper-".concat(name) : undefined;
  var buttonLabel = value && value.length > 0 ? "".concat(label, " (").concat(value.length, ")") : label;
  var handleOpenFilter = (0, _react.useCallback)(function (event) {
    onOpen();
    setAnchorEl(event.currentTarget);
  }, [onOpen]);
  var handleCloseFilter = (0, _react.useCallback)(function () {
    return setAnchorEl(null);
  }, []);
  var handleSelectItem = (0, _react.useCallback)(function (index, checked, option) {
    if (!option.disabled) {
      var selectedValues = checked ? (0, _ramda.remove)(index, 1, value) : (0, _ramda.append)(option, value);
      onChange(name, selectedValues, option, !checked);
    }
  }, [onChange, value, name]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Box, buttonBoxProps, /*#__PURE__*/_react["default"].createElement(_BaseButton["default"], {
    width: "100%",
    variant: "outlined",
    "aria-describedby": id,
    "data-testid": (0, _utils.toUnderscore)("multi-select-filter-".concat(name)),
    color: colors.grey.main,
    hoverColor: colors.grey.main,
    bgColor: colors.common.white,
    borderColor: colors.grey.regular,
    onClick: handleOpenFilter,
    disabled: disabled,
    overrideClass: classes.disabled
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    width: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "Body-Regular-Left-Inactive"
  }, buttonLabel), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: open ? 'chevron-up' : 'chevron-down'
  })))), /*#__PURE__*/_react["default"].createElement(_material.Popper, {
    id: id,
    open: open,
    transition: true,
    anchorEl: anchorEl,
    placement: "bottom-start",
    className: (0, _classnames["default"])(classes.popper, overrideClasses.popper)
  }, function (_ref3) {
    var TransitionProps = _ref3.TransitionProps,
        placement = _ref3.placement;
    return /*#__PURE__*/_react["default"].createElement(_material.Grow, (0, _extends2["default"])({}, TransitionProps, {
      style: {
        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
      }
    }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_material.ClickAwayListener, {
      onClickAway: handleCloseFilter
    }, /*#__PURE__*/_react["default"].createElement(_material.Box, null, isLoading && /*#__PURE__*/_react["default"].createElement(_material.Box, {
      width: 250,
      height: 60,
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      pl: 2
    }, /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
      className: classes.loadIcon,
      color: "inherit",
      size: 32
    }), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
      className: "Body-Regular-Left-Static"
    }, "Loading...")), /*#__PURE__*/_react["default"].createElement(_material.List, {
      className: classes.root
    }, options.map(function (option) {
      var labelId = "checkbox-list-label-".concat(option.id);
      var labelText = "".concat(option.label, " ").concat(option.count && option.count > 0 ? "(".concat(option.count, ")") : '');
      var optionIndex = value.findIndex(function (item) {
        return item.id === option.id;
      });
      var checked = optionIndex !== -1;
      return /*#__PURE__*/_react["default"].createElement(_material.ListItem, {
        classes: {
          dense: classes.listOption
        },
        key: option.type ? "".concat(option.type, "-").concat(option.id) : option.id,
        role: undefined,
        dense: true,
        button: true,
        onClick: function onClick() {
          return handleSelectItem(optionIndex, checked, option);
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.ListItemIcon, {
        classes: {
          root: classes.listIcon
        }
      }, option.disabled ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: classes.lockIcon,
        icon: "lock",
        color: "grey.main"
      }) : /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
        edge: "start",
        disabled: option.disabled,
        checked: checked,
        tabIndex: -1,
        disableRipple: true,
        "data-testid": (0, _utils.toUnderscore)("multi-select-filter-checkbox-".concat(name, "-").concat(option.label)),
        color: "primary",
        classes: {
          root: (0, _classnames["default"])(classes.checkbox, overrideClasses.checkbox)
        },
        inputProps: {
          'aria-labelledby': labelId
        }
      })), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, {
        classes: {
          primary: classes.listOptionText
        },
        className: "Body-Regular-Left-Static",
        id: labelId,
        "data-testid": (0, _utils.toUnderscore)("multi-select-filter-checkbox-text-".concat(name, "-").concat(option.label)),
        primary: labelText
      }));
    }))))));
  }));
}